import _ from 'lodash';
import { DefaultLanguageKeys } from '@tradingblock/types';
export const isFieldValueFilled = (value) => !!value || _.isNumber(value);
export const getCleanTranslationKey = (key) => {
    return key && key.replace(/\[\d+\]/, '').replace(/\.$/, '');
};
const getTranslationId = (options) => {
    const { id, type, page, textKey } = options;
    // get clean key, no translation keys for multiple fields
    const translateId = getCleanTranslationKey(id);
    let prefix = `${type || 'page'}s`;
    if (type === 'page' || (!type && !_.startsWith(translateId, 'defaults'))) {
        prefix += `.${page || 'defaults'}`;
    }
    let suffix = textKey;
    if (!suffix) {
        if (type === 'field') {
            suffix = DefaultLanguageKeys.Label;
        }
        else if (type === 'error') {
            if (!_.endsWith(translateId, `.${DefaultLanguageKeys.Error}`)) {
                suffix = DefaultLanguageKeys.Error;
            }
        }
        else {
            suffix = DefaultLanguageKeys.Text;
        }
    }
    // TODO: Review translations, expandedKey logic to correclty accomodate for error keys
    if (!_.endsWith(suffix, DefaultLanguageKeys.Error) && type === 'error') {
        suffix += '.error';
    }
    return `${prefix}.${translateId}${suffix ? `.${suffix}` : ''}`;
};
const getFieldTranslationId = (options) => {
    return `${options.defaultLabelId ? `defaults.${options.defaultLabelId}` : options.id}${options.option ? `.${options.option}` : ''}`;
};
export const useLocalize = () => {
    return {
        getCleanTranslationKey,
        getTranslationId,
        getFieldTranslationId,
    };
};
//# sourceMappingURL=useLocalize.js.map